<template>
  <v-container class="fill-height" fluid style="min-height: 100vh">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-card class="pa-8 text-center" elevation="2" rounded="lg">
          <v-avatar color="primary" size="88" class="mb-6">
            <v-icon dark size="48">mdi-truck-fast</v-icon>
          </v-avatar>

          <h1 class="text-h5 font-weight-bold mb-3">
            {{ title }}
          </h1>

          <p class="text-body-1 mb-8" style="opacity: 0.8; line-height: 1.6">
            {{ description }}
          </p>

          <v-btn
            color="primary"
            x-large
            block
            :href="kurirUrl"
            class="mb-3"
          >
            <v-icon left>mdi-open-in-new</v-icon>
            {{ buttonLabel }}
          </v-btn>

          <v-btn text block color="grey darken-1" @click="logout">
            <v-icon left>mdi-logout</v-icon>
            {{ logoutLabel }}
          </v-btn>
        </v-card>

        <p class="text-center text-caption mt-4" style="opacity: 0.6">
          {{ kurirUrl }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Shown to delivery dispatchers / couriers (admin_delivery, dostava) who log
// into the restaurant-admin app by mistake. The router hard-redirects every
// route to this page for those roles — the only actions here are "open the
// Kurir app" and "log out".
export default {
  name: "DeliveryAppRedirect",
  data() {
    return {
      kurirUrl: "https://kurir.ordera.app",
      title: "Ova aplikacija nije za dispečere",
      description:
        "Kao dispečer ili kurir dostavne firme, sve radite kroz Kurir aplikaciju — narudžbe, kurire i korisnike firme. Restoranska aplikacija vam nije potrebna.",
      buttonLabel: "Otvori Kurir aplikaciju",
      logoutLabel: "Odjava",
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("user/LOGOUT");
      this.$router.push({ name: "auth-login" }).catch(() => {});
    },
  },
};
</script>
